const getTabId = (id?: number | string, index?: number | string) => {
  if (id && index !== undefined) {
    return `${id}:tabs:${index}`;
  }
};

export default getTabId;
